import React from 'react'
import Raven from 'raven-js'
import PropTypes from 'prop-types'
import { HelmetProvider } from 'react-helmet-async'
import ScrollToTop from '../../containers/scroll-to-top'
import {
  GetHrefContext,
  ServerErrorContext,
  RavenContext,
  AgentInfoContext,
  CountryContext,
} from '../../../shared/context'
import { agentInfo } from '../../../shared/helpers/get-browser'
import getCountry from '../../../shared/helpers/get-country'

// Call the first thing once, then show subsequent from then on
const firstOnce = (first, subsequent) => {
  let called = false
  return (...args) => {
    if (called) {
      return subsequent
    }

    called = true
    return first(...args)
  }
}

// Flash the server error just once
const getServerError = firstOnce(() => window.__SERVER_ERROR__, undefined)

const getHref = () =>
  (typeof window !== 'undefined' && window.location.href) || ''

const getAgent = () =>
  (typeof navigator !== 'undefined' && navigator.userAgent) || ''

const ApplicationWrapper = ({ children, ...props }) => (
  <ScrollToTop>
    <HelmetProvider>
      <ServerErrorContext.Provider value={getServerError()}>
        <GetHrefContext.Provider value={getHref}>
          <RavenContext.Provider value={Raven}>
            <AgentInfoContext.Provider value={agentInfo(getAgent())}>
              <CountryContext.Provider value={getCountry()}>
                {children}
              </CountryContext.Provider>
            </AgentInfoContext.Provider>
          </RavenContext.Provider>
        </GetHrefContext.Provider>
      </ServerErrorContext.Provider>
    </HelmetProvider>
  </ScrollToTop>
)

ApplicationWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ApplicationWrapper
